import React, { useEffect, useState } from 'react'
import './style.scss'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { BsDatabaseFillX } from 'react-icons/bs'
import { accountingAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { useNavigate, useSearchParams } from 'react-router-dom'
import NormalInput from '../../components/common/inputs/NormalInput'


const SalesBillsHistory = () => {
    const navigate = useNavigate()
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState('fetch')
    const [searchParams, setSearchParams] = useSearchParams();

    const handleChangeDate = (e) => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set('date', e.target.value);
        setSearchParams(newSearchParams);
    }

    const fetchData = () => {
        setLoading('fetch')

        // Fetch data
        accountingAxios.get(`/sales/bills/history/${searchParams.get('date')}`).then((response) => {
            setLoading('')
            setData(response.data || [])
        }).catch((error) => {
            setLoading('')
            toast.error(error.message)
        })
    }

    useEffect(() => {
        if (searchParams.get('date')?.length === 7) {
            fetchData()
        } else {
            setLoading('')
        }
        // eslint-disable-next-line
    }, [searchParams.get('date')])

    return (
        <div className="sales-bills-list-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Sales Bill History']}>

                <div className="top-div">
                    <NormalInput label='Choose month' type='month' name='month' value={searchParams.get('date')}
                        onChangeFun={handleChangeDate} />
                </div>

                {data[0] ? <TableFilter srlNo={true} >
                    <table>
                        <thead>
                            <tr>
                                <th>Prospect ID</th>
                                <th>Name</th>
                                <th>Status</th>
                                <th>Action Date</th>
                                <th>Action By</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((prospect, index) => (
                                <tr key={index} >
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{prospect?.prospect_id}</td>
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{prospect?.first_name} {prospect?.last_name}
                                        <br></br>
                                        {prospect?.address?.address}, {prospect?.address?.place}, {prospect?.address?.city}
                                    </td>
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{prospect?.bills_verification?.status === 1 ? 'Accepted' : 'Rejected'}</td>
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{new Date(prospect?.bills_verification?.action_date).toDateString()}, {new Date(prospect?.bills_verification?.action_date).toLocaleTimeString()}</td>
                                    <td onClick={() => navigate(`/sales/item/${prospect?.prospect_id}/view`)}>{prospect?.action_by}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableFilter>
                    : <SpinWithMessage icon={!loading && <BsDatabaseFillX />} message={loading ? 'Fetch data...' : 'No data'} spin={loading} />
                }
            </SinglePage>
        </div>
    )
}

export default SalesBillsHistory